import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/question`;

export default class Question {
    constructor(question ={}) {
        this.questionId = question.questionId || "";
        //this.questionTitle=question.questionTitle||"";
        //this.questionDescription=question.questionDescription||"",
        //this.questionImage = question.questionImage || null,
        this.questionAudio = question.questionAudio|| "",
        this.questionStatus = question.questionStatus || true,
        this.questionKeySequence=question.questionKeySequence||[],
        this.questionStatement=question.questionStatement||""
    }

    //to get all admin users in AdminUsers.vue page
    static get = async (token) => {
        return axios.get(`${url}`, {headers:{"x-auth-token":token}});}

    static getQuestionInfo = async ( question_id, token) => {
        console.log('questioninfo question_id', question_id);
        return  axios.get(`${url}/questioninfo/${question_id}`, {headers:{"x-auth-token":token}});
    }

    //api to get course count in Dashboard.vue page
    static getQuestionCount = async (token) => {
        console.log('get question count client')
        return  axios.get(`${url}/questioncount`, {headers:{"x-auth-token":token}});
    }  

    // static getCountCourse = async (token) => {
    //     return  axios.get(`${url}/coursecount`, {headers:{"x-auth-token":token}});
    // }

    static postQuestion(token, formData) {
        console.log('client post question', formData );
        return axios.post(`${url}/newquestion`, formData ,{headers:{"x-auth-token":token,'Content-Type': 'multipart/form-data' }});
    }

    static putQuestion(question_id, formData, token) {
        return axios.put(`${url}/updatequestion/${question_id}`, formData, {headers:{"x-auth-token":token}});
    }
}
